/**
 * Adds a uid computed property that generates a unique identifier
 * that stays the same during the lifetime of the component
 */

import uidGenerator from '@utils/UIDGenerator.js'

export default {
  computed: {
    uid() {
      return uidGenerator()
    },
  },
  methods: {
    getUID() {
      return uidGenerator()
    },
  },
}
